
const useScrollToTop = () => {
  const scrollToTop = () => {
    const applicationWrapper = document.getElementById('applicationWrapper')
    if (applicationWrapper) {
      applicationWrapper.scrollTop = 0
    }
  }

  return { scrollToTop }
}

export default useScrollToTop
